import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"


export default function useBanners(props, emit, banner) {

    // Get toast interface
    const toast = useToast()

    const bannerStatus = ref("")
    const search = ref("")
    const perPage = ref(10)
    const sortField = ref("updated_at")
    const sortDirection = ref("desc")
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getBanners = (url = null) => {
        store.dispatch("getBanners", {
            url,
            search: search.value,
            status: bannerStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }


    const onSubmit = () => {
        loading.value = true

        if (banner.value.id) {
            store.dispatch('updateBanner', banner.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("بنر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getBanners")
                        closeModal()
                    }
                })

        } else {
            store
                .dispatch("createBanner", banner.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success("بنر با موفقیت افزوده شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getBanners")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }

    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        const input = document.getElementById("formFile")
        input.value = ""
        banner.value.ads_image = null
        emit("close")
    }


    return {
        show,
        bannerStatus,
        search,
        perPage,
        loading,
        errors,
        getBanners,
        onSubmit,
        closeModal,
    }
}